import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';
import { isSupportedFeature, constants as features } from '@saucelabs/sl-component-supported-feature';

import jobsReducer from './reducers';

const importFlatBuilds = () => import(/* webpackChunkName: "jobs-flat-builds" */ './containers/FlatBuildsContainerWrapper');
const importFlatJobs = () => import(/* webpackChunkName: "jobs-flat-jobs" */ './containers/FlatJobsContainerWrapper');
const importFlatManualJobs = () => import(/* webpackChunkName: "jobs-flat-manual-jobs" */ './containers/FlatManualJobsContainerWrapper');
const importFlatHeadlessJobs = () => import(/* webpackChunkName: "jobs-flat-headless-jobs" */ './containers/FlatHeadlessJobsContainerWrapper');

const JobsRoutes = ({ location, match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.RDC_WEB}>
      <Switch>
        <Redirect
          from="/dashboard/onboarding"
          strict
          to="/getting-started"
        />
        <Redirect
          from="/dashboard/tests/:cloudType"
          push
          to="/dashboard/tests"
        />
        <BundleRoute
          exact
          load={importFlatBuilds}
          path={`${match.url}/builds/:cloudType(rdc|vdc)`}
        />
        <BundleRoute
          load={importFlatBuilds}
          path={`${match.url}/builds`}
        />
        {isSupportedFeature(features.DASHBOARD_TAB_AUTOMATED_BUILDS) ? (
          <BundleRoute
            load={importFlatJobs}
            path={`${match.url}/tests`}
          />
        ) : (
          <BundleRoute
            load={importFlatHeadlessJobs}
            path={`${match.url}/tests`}
          />
        )}

        {isSupportedFeature(features.LIVE_TESTING) && (
          <BundleRoute
            load={importFlatManualJobs}
            path={`${match.url}/live/:cloudType(rdc|vdc)?`}
          />
        )}
        <Redirect
          to={{
            pathname: `${match.url}/tests`,
            search: location.search,
          }}
        />
      </Switch>
    </SentryBoundary>
  </LoginRequiredContainer>
);

JobsRoutes.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default dynamic(
  'apps.jobs', attachReducer(jobsReducer),
)(JobsRoutes);
export { JobsRoutes };
